import { Axios } from "../utils/axios.js";

export const gradeDownload = params => {
  const data = {
    examMemberName: params.examMemberName,
    examinationId: params.examNameId,
    examStartTime: params.examStartTime
  };
  return Axios.get("/trainAdmin/questionMemberInfo/export", {
    params: data,
    responseType: "arraybuffer"
  });
};



// WEBPACK FOOTER //
// ./src/api/grade.js